<template>
  <div class="bm-apply-for" >
    <div class="title" >选择参赛球队或新建球队</div>
    <div class="main" >
      <div @click="routerCreate" >创建球队</div>
      <div v-if="teams.length" >选择球队</div>
    </div>
    <van-checkbox-group  v-model="result" style="padding-bottom: 50px;">
      <van-cell-group class="checkbox" >
        <van-cell v-for="(item, index) in teams" clickable :key="item.id" @click="toggle(index)">
          <div class="team" >
            <div>
              <img :src="item.badge | formatImg" alt="img">
            </div>
            <div>
              <p>{{item.name}}</p>
              <span>{{item.location}}</span>
            </div>
          </div>
          <van-checkbox :name="item.id" ref="checkboxes" />
        </van-cell>
      </van-cell-group>
    </van-checkbox-group>
    <div class="foot" @click="submitAction">
      提交申请
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { ImageFormat } from '@/utils'
import { getMyTeamsForMatch, signupBMMatchTeams } from '@/api/match'
import { Checkbox, CheckboxGroup, Toast } from 'vant'

Vue.use(Checkbox).use(CheckboxGroup).use(Toast)

export default {
  name: 'ApplyFor',
  data() {
    return {
      teams: [],
      match: {},
      result: [],
      query: this.$route.query
    }
  },
  computed: {
  },
  created() {
    this.getMyTeamsForMatch()
  },
  methods: {
    routerCreate: function () {
      this.$router.push({ name: 'InviteCreateTeam', query: {matchId: this.query.matchId} })
    },
    toggle(index) {
      this.$refs.checkboxes[index].toggle()
    },
    getMyTeamsForMatch: function() {
      getMyTeamsForMatch(this.query.matchId).then(response => {
        const data = response.data
        this.teams = data.teams
        this.teams = this.teams.filter((item) => {
          return item.auditStatus !== 2
        })
        this.match = data.match
      })
    },
    submitAction: function () {
      if (this.result.length > 0) {
        this.signupBMMatchTeams()
      } else {
        Toast('请至少选择一支球队')
      }
    },
    signupBMMatchTeams: function() {
      const params = {
        matchId: this.query.matchId,
        teamIds: this.result.join()
      }
      signupBMMatchTeams(params).then(response => {
        const data = response.data
        if (data && data.update) {
          this.$router.push({ name: 'ApplyDone' })
        }
      })
    }
  },
  filters: {
    formatImg: function (value) {
      return ImageFormat.squareImageView(value, 104)
    }
  }
}
</script>

<style lang="stylus">
.bm-apply-for
  background-color: white
  width 100%
  height: 100%
  position absolute
  .title
    font-size: 30px;
    font-weight: 400;
    color: rgba(0,0,0,1);
    padding: 10px 15px;
  .main
    padding: 0 15px;
    div:first-child
      font-size:18px;
      font-weight:400;
      color:rgba(50,163,119,1);
    div:nth-child(2)
      color: #000
      padding-top: 20px
      padding-bottom: 10px
      font-size:18px;
      font-weight:400;
  .team
    display inline-flex
    width: calc(100% - 30px)
    div:first-child
      width 52px
      height 52px
      margin-right: 10px
      img
        width 52px
        height 52px
    div:nth-child(2)
      display flex
      flex-direction column
      justify-content: space-between;
      width: calc(100% - 112px)
      p
        margin: 0;
        font-size:14px;
        font-weight:400;
        color:rgba(0,0,0,1);
      span
        font-size:12px;
        font-weight:400;
        color:rgba(129,129,129,1);
  .team+.van-checkbox
    display inline
  .checkbox
    .van-cell
      .van-cell__value
        display flex
        align-items: center
  .van-hairline--top-bottom::after
      border-width 0
  .foot
    padding: 10px 0
    background: rgba(250,250,250,1);
    text-align center
    position fixed
    bottom: 0
    width: 100%
    font-size:20px;
    font-weight:400;
    color:rgba(50,163,119,1);
    max-width: 480px;
</style>



// WEBPACK FOOTER //
// src/pages/invite/apply-for.vue